module.exports = __webpack_public_path__ + "img/SB.3d4f88c3.svg";